import { graphql } from "@/types/gql";

export const QUERY_DECREES_PAGINATED = graphql(`
  query DecreesPaginated(
    $cityId: String!
    $pageIndex: Int!
    $sortOrder: SortOrder
    $sortField: String
    $pageSize: Int!
    $filter: [FilterInput!]
  ) {
    decreesPaginated(
      cityId: $cityId
      pageIndex: $pageIndex
      sortOrder: $sortOrder
      sortField: $sortField
      pageSize: $pageSize
      filter: $filter
    ) {
      results {
        __typename
        id
        name
        createdAt
        cityId
        done
        publicUrl
        analyzed
        category
        comments
        publishedDate
        title
        decreeNumber
        ... on TemporaryDecree {
          temporaryType: type
          extension {
            originalDecreeReference
            originalDecreeNumber
          }
          restrictionsCount
        }
        ... on PermitDecree {
          permitType: type
          startDate
          endDate
        }
      }
      totalPages
      totalCount
    }
  }
`);

export const QUERY_TEMPORARY_DECREES_PAGINATED = graphql(`
  query TemporaryDecreesPaginated(
    $cityId: String!
    $pageIndex: Int!
    $sortOrder: SortOrder
    $sortField: String
    $pageSize: Int!
    $filter: [FilterInput!]
  ) {
    temporaryDecreesPaginated(
      cityId: $cityId
      pageIndex: $pageIndex
      sortOrder: $sortOrder
      sortField: $sortField
      pageSize: $pageSize
      filter: $filter
    ) {
      results {
        __typename
        id
        name
        createdAt
        cityId
        done
        publicUrl
        analyzed
        category
        comments
        publishedDate
        title
        decreeNumber
        temporaryType: type
        extension {
          originalDecreeReference
          originalDecreeNumber
        }
        restrictionsCount
      }
      totalPages
      totalCount
    }
  }
`);

export const CHANGE_DECREE_CATEGORY = graphql(`
  mutation UpdateDecreeCategory($id: ID!, $input: UpdateDecreeCategoryInput!) {
    updateDecreeCategory(id: $id, input: $input) {
      id
      category
    }
  }
`);

export const REMOVE_DECREE = graphql(`
  mutation RemoveDecree($id: ID!) {
    removeDecree(id: $id) {
      id
    }
  }
`);

export const UPDATE_PERMANENT_DECREE_MUTATION = graphql(`
  mutation UpdatePermanentDecree($updateDecreeInput: UpdatePermanentDecreeInput!) {
    updatePermanentDecree(updateDecreeInput: $updateDecreeInput) {
      id
    }
  }
`);

export const UPDATE_TEMPORARY_DECREE_MUTATION = graphql(`
  mutation UpdateTemporaryDecree($updateDecreeInput: UpdateTemporaryDecreeInput!) {
    updateTemporaryDecree(updateDecreeInput: $updateDecreeInput) {
      id
    }
  }
`);

export const UPDATE_PERMIT_DECREE_MUTATION = graphql(`
  mutation UpdatePermitDecree($updateDecreeInput: UpdatePermitDecreeInput!) {
    updatePermitDecree(updateDecreeInput: $updateDecreeInput) {
      id
    }
  }
`);

export const QUERY_TEMPORARY_DECREE_BY_ID = graphql(`
  query TemporaryDecree($id: String!, $cityId: String!) {
    temporaryDecree(cityId: $cityId, id: $id) {
      id
      restrictions {
        id
        timeSpans {
          startDate
          endDate
          daysOfWeek
          daysOfMonth
          months
          timeOfDayStart
          timeOfDayEnd
        }
        decreeIds
        streetName
        streetNumberStart
        streetNumberEnd
        geometry
        curbZoneId
        decreeIds
        description
        editLine
        geoPoint2d
        type
        cityId
        width
        calculatedSpaces
        length
      }
    }
  }
`);

export const UPDATE_DECREE_MUTATION = graphql(`
  mutation UpdateDecree($updateDecreeInput: UpdateDecreeInput!) {
    updateDecree(input: $updateDecreeInput) {
      id
    }
  }
`);
